'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import unescapedText from 'I18n/utils/unescapedText';
import { push } from '../../utils/history';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIErrorMessage from 'UIComponents/error/UIErrorMessage';
import UIButton from 'UIComponents/button/UIButton';

const NotFoundError = () => {
  return /*#__PURE__*/_jsx(UIErrorMessage, {
    type: "notFound",
    title: unescapedText('appMarketplace.error.notFound.title'),
    children: /*#__PURE__*/_jsx(UIButton, {
      use: "tertiary",
      className: "m-top-4",
      onClick: () => push('/'),
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "appMarketplace.error.notFound.button"
      })
    })
  });
};

export default NotFoundError;